import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
const StickyHeadTestCasesTable = ({allData}) => {

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={3} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}></TableCell>
            <TableCell align="center" colSpan={allData.SW_master_column.length} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>Platform - SW Master</TableCell>
            <TableCell align="center" colSpan={allData.caesar_column.length} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>Caesar</TableCell>
            <TableCell align="center" colSpan={allData.cardio_app_column.length} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>Cardio App</TableCell>
            <TableCell align="center" colSpan={allData.qtc_odm_column.length} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>Qbert/Topaz/Caspian ODM</TableCell>
            <TableCell align="center" colSpan={allData.ar_odm_column.length} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>Amber/Redstone ODM</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}></TableCell>
            {allData.SW_master_column.map((column) => (
              <TableCell key={column.id} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>{column.label}</TableCell>
            ))}
            {allData.caesar_column.map((column) => (
              <TableCell key={column.id} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>{column.label}</TableCell>
            ))}
            {allData.cardio_app_column.map((column) => (
              <TableCell key={column.id} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>{column.label}</TableCell>
            ))}
            {allData.qtc_odm_column.map((column) => (
              <TableCell key={column.id} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>{column.label}</TableCell>
            ))}
            {allData.ar_odm_column.map((column) => (
              <TableCell key={column.id} sx={{ position: 'sticky', left: 0, bgcolor: "#406599", color: "white", border: 1, zIndex: 1 }}>{column.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {allData.data.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              {row.types.map((type, typeIndex) => (
                <TableRow key={typeIndex}>
                  {typeIndex === 0 && (
                    <>
                    <TableCell rowSpan={row.types.length}>{row.month}</TableCell>
                    </>
                  )}
                  <TableCell style={{ backgroundColor: type.backgroundColor }}>{type.label}</TableCell>
                  <TableCell style={{ backgroundColor: type.backgroundColor }}>{type.count}</TableCell>
                  {allData.SW_master_column.map((column) => (
                    <TableCell key={column.id} >{type.values[column.name]}</TableCell>
                  ))}
                  {allData.caesar_column.map((column) => (
                    <TableCell key={column.id} >{type.values[column.name]}</TableCell>
                  ))}
                  {allData.cardio_app_column.map((column) => (
                    <TableCell key={column.id} >{type.values[column.name]}</TableCell>
                  ))}
                  {allData.qtc_odm_column.map((column) => (
                    <TableCell key={column.id} >{type.values[column.name]}</TableCell>
                  ))}
                  {allData.ar_odm_column.map((column) => (
                    <TableCell key={column.id} >{type.values[column.name]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default StickyHeadTestCasesTable;